<script>
import Pagination from '@/components/Pagination'
import ErrorComponent from '@/components/ErrorComponent'
import Alert from '@/components/Alert'
import EventBus from '@/eventBus'
import accessible from '@/mixins/accessible'

export default {
  name: 'Employees',

  components: {
    Pagination,
    ErrorComponent,
    Alert
  },

  data() {
    return {
      query: '',
      storeListOrigin: [],
      user: {
      },
      country_code: '',
      currentPage: 1,
      totalPage: 0,
      itemsPerPage: 10,
      list: [],
      storeList: [],
      selectedStores: [],
      checkedEmployee: [],
      roleList: [],
      currentSorting: '',
      employee: {
        name: '',
        username: '',
        password: '',
        email: '',
        phone_number: '',
        role_id: '',
        is_available_all_stores: false,
        is_force_available_all_stores: false,
      },
      force_update_employee_password: false,
      isAll: false,
      role_pos: false,
      role_owner: false,
      availableStoreStr: '',
      last_login: '',
      stores: [],
      filterObj: {
        sort_by: '',
        order_by: 'ASC',
        store_id: '',
        search: ''
      },
      employeeAdd : false,
      isOwner: false
    }
  },

  mixins: [accessible],

  methods: {
    searchStores(event) {
      if(this.query == ""){
        this.storeList = this.storeListOrigin
      }else{
        this.storeList = this.$flowFilter(this.storeListOrigin, this.query)
      }
    },

    checkAllcheckedEmployee(event) {
      this.checkedEmployee = []
      if (event.target.checked) {
        for (var i = 0; i < this.list.length; i++) {
          if (!this.list[i].is_checked) {
            this.checkedEmployee.push(this.list[i].id)
          }
        }
      }
    },

    checkUncheckEmployee(e, is_checked) {
      if (this.$refs.spr_1) {
        if (
          this.checkedEmployee.length > 0 &&
          this.checkedEmployee.length == this.list.length
        ) {
          this.$refs.spr_1.checked = true
        } else {
          this.$refs.spr_1.checked = false
        }
      }
    },

    pageChange(page) {
      this.getList(page)
    },

    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage
      this.getList(1)
    },

    getList(page, sortBy, orderBy, store_id) {
      this.list = []
      this.currentPage = page

      if (sortBy) {
        this.filterObj.sort_by = sortBy
      }
      if (orderBy) {
        this.filterObj.order_by = orderBy
      }

      if (this.store_id) {
        this.filterObj.store_id = store_id
      }

      if (this.search) {
        this.filterObj.search = search
      }

      this.$api
        .getAPI({
          _action: '/employee/list/' + this.itemsPerPage + '/' + page,
          _body: this.filterObj
        })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.list = res.list
          }
          if (page == 1) {
            if (res.count != null && res.count > 0) {
              this.$refs.listPagination.setTotalCount(res.count)
            } else {
              this.$refs.listPagination.setTotalCount(0)
            }
          }

          if (!res.list || res.list.length <= 0) {
            this.$refs.errorComonent.setTitle(
              this.$lang.messages.no_employee_found
            )
          } else if (this.$refs.errorComonent.isShowMessage()) {
            this.$refs.errorComonent.setTitle()
          }
        })
        .catch(e => {
          this.$refs.errorComonent.setTitle()
        })
    },

    sorting(e, sortBy) {
      var orderBy = 'ASC'

      var className = 'sorting_asc'
      var classes = e.target.className
      if (classes.includes('sorting_asc')) {
        className = 'sorting_desc'
      }

      $('.sorting_asc').removeClass('sorting_asc')
      $('.sorting_desc').removeClass('sorting_desc')

      if (className == 'sorting_asc') {
        $(e.target)
          .addClass('sorting_asc')
          .removeClass('sorting_desc')
        orderBy = 'ASC'
      } else if (className == 'sorting_desc') {
        $(e.target)
          .addClass('sorting_desc')
          .removeClass('sorting_asc')
        orderBy = 'DESC'
      }

      this.getList(1, sortBy, orderBy)
    },

    getStoreList() {
      this.storeList = []
      this.storeListOrigin = []
      this.$api
        .getAPI({ _action: `/store/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}` })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.storeList = res.list
            this.storeListOrigin = res.list
          }
        })
        .catch(e => {})
    },

    getRoleList() {
      this.roleList = []
      this.$api
        .getAPI({ _action: '/role/list' })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.roleList = res.list
          }
        })
        .catch(e => {})
    },

    checkUncheckStore(event) {
      this.setAvailableStr()
      if (event && !event.target.checked) {
        if(!this.isOwner){
          this.isAll = false
        }
      }
    },

    saveDuplicatedName(e){
      this.employee.ignore_duplicated = true
      this.$refs.duplicatedItemAlert.close()
      this.save()
    },

    saveNoneCustomerStore(e){
      this.employee.force_allow_none_store = true
      this.$refs.noneCustomerStore.close()
      this.save()
    },
    saveAvailableAllStore(e){
      this.employee.is_force_available_all_stores = true
      this.$refs.confirmAvailableAllStores.close()
      this.save()
    },

    checkAllStores(event) {
      this.availableStoreStr = ''
      if (this.isAll) {
        for (var i = 0; i < this.storeList.length; i++) {
          if(this.selectedStores.indexOf(this.storeList[i].id) == -1){
            this.selectedStores.push(this.storeList[i].id)
          }
        }
      }else{
        for (var i = 0; i < this.storeList.length; i++) {
          this.selectedStores = this.selectedStores.filter(item => item !== this.storeList[i].id)
        }
      }
      this.setAvailableStr()
    },

    setAvailableStr() {
      var nAvailableStore = 0
      for(let i = 0; i < this.selectedStores.length; i++){
        if(this.$_.findIndex(this.storeListOrigin, {'id': this.selectedStores[i]}) != -1){
          nAvailableStore += 1
        }
      }

      if(!this.isOwner){
          this.isAll = false
      }
      if(nAvailableStore == this.storeListOrigin.length){
        if(!this.isOwner){
          this.isAll = true
        }
      }
      this.availableStoreStr = ''
      if (this.selectedStores.length > 0) {
        if (this.isAll) {
          if(this.role_owner) {
            this.availableStoreStr = this.$lang.messages.automatically_assigned_to_all_stores;
          }else{
            this.availableStoreStr = this.$lang.messages.assigned_to_all_stores
          }
        } else {
          if (nAvailableStore == 1) {
            this.availableStoreStr = `${this.$lang.messages.assigned_to} 1 ${this.$lang.messages.store.toLowerCase()}`
          } else if(nAvailableStore > 0) {
            this.availableStoreStr =
              `${this.$lang.messages.assigned_to} ${nAvailableStore} ${this.$lang.messages.stores.toLowerCase()}`
          }
        }
      }
    },

    details(id) {
      this.employee = {}
      this.selectedStores = []
      this.$api
        .getAPI({ _action: '/employee/detail/' + id })
        .then(res => {
          this.employee = res
          this.isAll = this.employee.is_available_all_stores
          if (res.role_id) {
            this.checkRolePos()
          }

          if (res.role == 'OWNER') {
            this.role_owner = true
          } else {
            this.role_owner = false
          }

          if (res.last_login) {
            this.last_login = res.last_login
          }

          if (res.stores && res.stores.length > 0) {
            for (var i = 0; i < res.stores.length; i++) {
              if (res.stores[i].is_available) this.selectedStores.push(res.stores[i].store_id)
            }
            if (this.selectedStores.length == this.storeList.length) {
              if(!this.isOwner){
                this.isAll = true
              }
            }
          } else {
            this.selectedStores = []
            if(!this.isOwner){
              this.isAll = false
            }
          }
          this.setAvailableStr()

          this.force_update_employee_password = false
        })
    },

    setObj(id) {
      this.employee.id = id
      this.$refs.deleteEmployeeAlert.message = this.$lang.messages.are_you_sure_you_want_to_delete_the_employee
    },

    validateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.save()
          return
        }
      });
    },
    showDeleteEmployeeAlert() {
      this.$refs.deleteMultipleEmployeeLink.click()
      this.$refs.deleteMultipleEmployeeAlert.message = this.$lang.messages.delete_multiple_employee_message
    },

    deleteSelectedEmployee() {
      for (var i = 0; i < this.checkedEmployee.length; i++) {
        this.$api
          .deleteAPI({
            _action: '/employee/delete/' + this.checkedEmployee[i]
          })
          .then(res => {
            if (i == this.checkedEmployee.length) {
              this.getList(1)
              this.checkedEmployee = []
              this.$refs.spr_1.checked = false
              this.$refs.deleteMultipleEmployeeAlert.close()
              this.$notify({
                group: 'foo',
                text: this.$lang.messages.deleted_successfully,
                type: 'success'
              })
            }
          })
          .catch(e => {
            this.getList(1)
          })
      }
    },

    save() {
      if (this.selectedStores.length > 0) {
        this.employee.stores = this.selectedStores
      } else {
        this.employee.stores = []
      }
      this.employee.is_available_all_stores = this.isAll

      if(this.isOwner && this.employee.is_available_all_stores && !this.employee.is_force_available_all_stores){
        this.$refs.confirmAvailableAllStores.message = this.$lang.messages.automatically_assigned_to_all_stores_desc
        $('#confirm-available-all-store').modal('show')
        return
      }

      localStorage.setItem('cacheVersion', Date.now())
      this.$api
        .postAPI({
          _action: '/employee/',
          _body: this.employee,
          _buttonId: 'save-btn'
        })
        .then(res => {
          this.$notify({
            group: 'foo',
            text: res.message,
            type: 'success'
          })
          document.getElementById('cancel-btn').click()
          this.getList(1)
        })
        .catch(e => {
          if (e.status == 409){
            this.$refs.duplicatedItemAlert.message = e.data.message
            $('#duplicated-customer-modal').modal('show')
          }
          if (e.status == 406){
            this.$refs.noneCustomerStore.message = e.data.message
            $('#none-customer-store-modal').modal('show')
          }
        })
    },

    sendEmailEmployee(){
      this.$api
        .postAPI({
          _action: '/employee/set_password/'  + this.employee.id,
          _buttonId: 'save-btn'
        })
        .then(res => {
          this.$refs.sendEmailEmployeeAlert.close()
          this.$notify({
            group: 'foo',
            text: res.message,
            type: 'success'
          })
          document.getElementById('cancel-btn').click()
          this.getList(1)
        })
        .catch(e => {
          this.$refs.sendEmailEmployeeAlert.close()
          console.log(e.message)
        })
    },

    gotoEmployeeAdd() {
      this.clearAddModal()
      this.query = ''
      this.storeList = this.storeListOrigin
      this.employeeAdd = true
      $('#AddEmployee').modal('show')
    },

    gotoEmployeeEdit(id) {
      this.query = ''
      this.storeList = this.storeListOrigin
      this.clearAddModal()
      this.details(id)
      this.employeeAdd = false
      $('#AddEmployee').modal('show')
    },

    sendEmailSetPassword(id){
      this.employee.id = id
      this.$refs.sendEmailEmployeeAlert.message = this.$lang.messages.send_set_password_link_to_employee_email
      $('#send-email-employee-modal').modal('show')
    },

    deleteEmployee(e) {
      if (this.employee.id) {
        this.$api
          .deleteAPI({
            _action: '/employee/delete/' + this.employee.id
          })
          .then(res => {
            this.$refs.deleteEmployeeAlert.close()
            this.$notify({
              group: 'foo',
              text: res.message,
              type: 'success'
            })
            this.employee.id = ''
            this.getList(1)
          })
          .catch(e => {
            this.$refs.deleteEmployeeAlert.close()
          })
      }
    },

    retry() {
      this.getList(1)
    },

    checkRolePos() {
      if (this.employee.role_id) {
        this.$api
          .getAPI({
            _action: '/role/detail/' + this.employee.role_id,
            _hide_loader: true
          })
          .then(res => {
            this.role_pos = res.pos
          })
      } else {
        this.role_pos = false
      }
    },

    clearAddModal() {
      this.employee.id = ''
      this.employee.name = ''
      this.employee.username = ''
      this.employee.email = ''
      this.employee.name = ''
      this.employee.phone_number = ''
      this.employee.password = ''
      this.employee.role_id = ''
      this.employee.stores = []
      this.selectedStores = []
      this.isAll = false
      this.role_id = false
      this.role_owner = false
      this.role_pos = false
      this.$validator.reset()
      this.errors.clear()
      // this.checkAllStores();
    },

    getMe(e) {
      this.$api
        .getAPI({
          _action: `/me?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}`
        })
        .then(res => {
          this.user = res.user

          if (res.days) {
            localStorage.setItem('days', res.days)
          }
        });
    },

    validateBeforeSubmit() {
      this.$validator.validateAll('modifier-form').then(result => {
        if (result) {
          this.setPin()
        }
        return
      })
    },

    showAddEmployeeAlert() {
      this.$refs.addMultipleEmployeeLink.click()
      //this.$refs.deleteMultipleEmployeeAlert.message = this.$lang.messages.delete_multiple_employee_message
    },

    toggleShowHidePassword() {
      $(document).ready(function() {
        $('#show_hide_password a').on('click', function(event) {
          event.preventDefault()
          if ($('#show_hide_password input').attr('type') == 'text') {
            $('#show_hide_password input').attr('type', 'password')
            $('#show_hide_password i').addClass('fa-eye-slash')
            $('#show_hide_password i').removeClass('fa-eye')
          } else if ($('#show_hide_password input').attr('type') == 'password') {
            $('#show_hide_password input').attr('type', 'text')
            $('#show_hide_password i').removeClass('fa-eye-slash')
            $('#show_hide_password i').addClass('fa-eye')
          }
        })
      })
    }
  },

  watch: {
    force_update_employee_password(val) {
      this.toggleShowHidePassword()
    }
  },

  mounted() {
    this.country_code = localStorage.getItem('country_code')
    this.getStoreList()
    this.getList(1)
    this.getRoleList()
    this.getMe()

    $('.search-box a, .search-box .app-search .srh-btn').on(
      'click',
      function() {
        $('.app-search').toggle(200)
        $('.app-search input').focus()
      }
    )

    // get current user profile
    EventBus.$on('GET_ME_SUCCESS', payload => {
      this.currentUser = payload
      this.isOwner = (this.currentUser.access_right.name == "OWNER")
    })

    this.toggleShowHidePassword()
  }
}
</script>

<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="mb-3 text-md-right text-center">
              <div
                class="text-right custom-select-dd d-inline-block mr-lg-3 mr-md-1 mb-lg-0 mb-3 w-xs-100"
                style="width: 160px">
                <select v-model="filterObj.store_id" @change="getList(1)" class="form-control">
                  <option value>{{$lang.messages.all_stores}}</option>
                  <option
                    v-for="store in storeList"
                    :key="store.id"
                    :value="store.id"
                  >{{store.name}}</option>
                </select>
              </div>
              <button
                type="button"
                v-if="checkedEmployee && checkedEmployee.length > 0"
                @click="showDeleteEmployeeAlert()"
                class="btn btn-light font-18"
                style="float: left"
              >
                <i class="far fa-trash-alt font-16 text-seconadry"></i>
              </button>
              <button
                type="button"
                class="btn bg-white search-box border-secondary rounded-5 mr-3"
                style="height: 42px"
              >
                <a class="text-secondary waves-effect waves-dark p-0" href="javascript:void(0)">
                  <i class="fas fa-search font-16"></i>
                </a>
                <form class="app-search position-absolute" v-on:submit.prevent>
                  <input
                    type="text"
                    class="form-control"
                    v-model="filterObj.search"
                    v-bind:placeholder="$lang.messages.search_enter"
                    v-on:keyup.enter="getList(1)"
                  />
                  <a class="srh-btn">
                    <i class="ti-close"></i>
                  </a>
                </form>
              </button>
              <button
                @click="gotoEmployeeAdd"
                class="btn btn-primary px-4"
              >+ {{$lang.messages.add_employee}}</button>
            </div>

            <div class="card rounded-5">
              <div class="card-body table-responsive">
                <table class="table table-striped table-style-1">
                  <thead>
                    <tr>
                      <th scope="col">Sr.no</th>
                      <th scope="col" width="40">
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            id="spr_1"
                            ref="spr_1"
                            @change="checkAllcheckedEmployee($event)"
                          />
                          <label class="custom-control-label text-dark ml-2" for="spr_1"></label>
                        </div>
                      </th>
                      <th
                        scope="col"
                        class="sorting"
                        @click="sorting($event, 'name')"
                      >{{$lang.messages.employee_name}}</th>

                      <th
                        scope="col"
                        class="sorting"
                        @click="sorting($event, 'name')"
                      >{{$lang.messages.username}}</th>

                      <th scope="col">{{$lang.messages.role}}</th>
                      <th class="text-right pr-lg-4">{{$lang.messages.action}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="clickable-row" v-for="(employee,i) in list" :key="employee.id">
                      <td>{{(currentPage -1) * itemsPerPage + i +1}}</td>
                      <td>
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :value="employee.id"
                            :id="'type_'  +employee.id"
                            v-model="checkedEmployee"
                            :disabled="employee.is_checked"
                            @change="checkUncheckEmployee($event)"
                          />
                          <label
                            class="custom-control-label text-dark ml-2"
                            :for="'type_' +employee.id"
                          ></label>
                        </div>
                      </td>
                      <td>{{employee.name}}</td>
                      <td>{{employee.username}}</td>
                      <td>{{employee.role}}</td>
                      <td class="text-right pr-lg-4 text-nowrap">
                        <a
                          @click="sendEmailSetPassword(employee.id)"
                          v-if="!employee.last_login"
                          href="javascript:void(0)"
                          class="text-primary mr-2 font-18">
                          <i class="mdi mdi-email"></i>
                        </a>
                        <a v-if="employee.role != 'OWNER' && !role_owner"
                          @click="gotoEmployeeEdit(employee.id)"
                          href="javascript:void(0)"
                          class="text-primary mr-2 font-18">
                          <i class="mdi mdi-pencil"></i>
                        </a>
                        <i
                          class="far fa-trash-alt font-20 text-danger"
                          data-toggle="modal"
                          data-target="#delete-employee-modal"
                          @click="setObj(employee.id)"
                          v-if="!employee.is_checked"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <ErrorComponent @retry="retry()" ref="errorComonent" />
              </div>
            </div>

            <div class="page-bottom-pagination text-right">
              <Pagination
                @page-change="pageChange"
                @items-per-page-change="itemsPerPageChange()"
                ref="listPagination"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <a
      @click="gotoEmployeeAdd()"
      href="javascript:void(0)"
      style="display: block"
      ref="addEmployeeLink"> </a>

    <div
      class="modal fade"
      id="AddEmployee"
      tabindex="-1"
      role="dialog"
      aria-labelledby="AddEmployee"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content px-lg-4 py-lg-4">
          <div class="modal-header border-0">
            <h5
              class="modal-title font-22"
            >{{employee.id ? $lang.messages.update_employee : $lang.messages.create_employee}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <form>
            <div class="modal-body form-style">
              <div class="row mb-4">
                <div class="col-lg-12 mb-4">
                  <label for>{{$lang.messages.name}}</label>
                  <span style="color:#ff0000">*</span>
                  <input
                    name="name"
                    v-model="employee.name"
                    v-validate="'required|max:300'"
                    maxlength="300"
                    class="form-control"
                    :class="{'input': true, 'is-danger': errors.has('name') }"
                    type="text"
                    v-bind:placeholder="$lang.messages.name"
                  />
                  <i v-show="errors.has('name')" class="fa fa-warning"></i>
                  <span
                    v-show="errors.has('name')"
                    class="help is-danger"
                  >{{$lang.messages.please_enter_valid_name}}</span>
                </div>

                <div v-if="employee.id" class="col-lg-12 mb-4">
                  <label for>{{$lang.messages.username}}</label>
                  <input
                    name="username"
                    :value="employee.username"
                    disabled
                    maxlength="300"
                    class="form-control input"
                    type="text"
                    v-bind:placeholder="$lang.messages.username"
                  />
                </div>

                <div v-else class="col-lg-12 mb-4">
                  <label for>{{$lang.messages.username}}</label>
                  <span style="color:#ff0000">*</span>
                  <input
                    name="username"
                    v-model="employee.username"
                    v-validate="'required|max:300'"
                    maxlength="300"
                    class="form-control"
                    :class="{'input': true, 'is-danger': errors.has('username') }"
                    type="text"
                    v-bind:placeholder="$lang.messages.username"
                  />
                  <i v-show="errors.has('username')" class="fa fa-warning"></i>
                  <span
                    v-show="errors.has('username')"
                    class="help is-danger"
                  >Please enter valid username</span>
                </div>

                <div v-if="employee.id" class="col-lg-12 mb-4">
                  <p class="mb-0">
                    {{ $lang.messages.update_password }}
                    <span class="switch switch-sm ml-3">
                      <input
                        type="checkbox"
                        v-model="force_update_employee_password"
                        id="switch-1"
                        class="switch"
                      />
                      <label for="switch-1"></label>
                    </span>
                  </p>

                  <div v-if="force_update_employee_password" class="mt-3">
                    <div class="input-group" id="show_hide_password">
                      <input
                        name="password"
                        v-model="employee.password"
                        v-validate.persist="'required|min:6'"
                        maxlength="300"
                        class="form-control"
                        :class="{'input': true, 'is-danger': errors.has('password') }"
                        type="password"
                        v-bind:placeholder="$lang.messages.password"
                      />

                      <div class="input-group-addon border border-left-0 py-1 px-2 border-secondary bg-light">
                        <a href style="vertical-align: sub;">
                          <i class="fa fa-eye-slash" aria-hidden="true"></i>
                        </a>
                      </div>
                    </div>
                    <i v-show="errors.has('password')" class="fa fa-warning"></i>
                      <span
                        v-show="errors.has('password')"
                        class="help is-danger"
                      >Please enter valid password</span>
                  </div>
                </div>

                <div v-else class="col-lg-12 mb-4">
                  <label>{{ $lang.messages.initial_password }}</label>
                  <span style="color:#ff0000">*</span>
                  <div class="input-group" id="show_hide_password">
                    <input
                      name="password"
                      v-model="employee.password"
                      v-validate="'required|min:6'"
                      maxlength="300"
                      class="form-control"
                      :class="{'input': true, 'is-danger': errors.has('password') }"
                      type="password"
                      v-bind:placeholder="$lang.messages.initial_password"
                    />

                    <div class="input-group-addon border border-left-0 py-1 px-2 border-secondary bg-light">
                      <a href style="vertical-align: sub;">
                        <i class="fa fa-eye-slash" aria-hidden="true"></i>
                      </a>
                    </div>
                  </div>

                  <i v-show="errors.has('password')" class="fa fa-warning"></i>
                  <span
                    v-show="errors.has('password')"
                    class="help is-danger"
                  >{{ $lang.messages.initial_password_validation }} 6 {{ $lang.messages.characters }}</span>
                </div>

                <div class="col-lg-12 mb-4" v-if="employee.id">
                  <label for>{{$lang.messages.email}} (Optional)</label>
                  <input
                    name="email"
                    v-model="employee.email"
                    :class="{ 'form-control' : true, 'input': true, 'is-danger': errors.has('email') }"
                    type="email"
                    v-bind:placeholder="$lang.messages.email"
                    v-validate="'email'"
                  />
                  <i v-show="errors.has('email')" class="fa fa-warning"></i>
                  <span
                    v-show="errors.has('email')"
                    class="help is-danger"
                  >{{$lang.messages.please_enter_email}}</span>
                </div>

                <div class="col-lg-12 mb-4" v-else>
                  <label for>{{$lang.messages.email}} (Optional)</label>
                  <input
                    name="email"
                    v-model="employee.email"
                    :class="{ 'form-control' : true, 'input': true, 'is-danger': errors.has('email') }"
                    type="email"
                    v-validate="'email'"
                    v-bind:placeholder="$lang.messages.email"
                  />
                  <i v-show="errors.has('email')" class="fa fa-warning"></i>
                  <span
                    v-show="errors.has('email')"
                    class="help is-danger"
                  >{{$lang.messages.please_enter_email}}</span>
                </div>

                <div class="col-lg-12 mb-4">
                  <label for>{{$lang.messages.mobile_number}} (Optional)</label>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <label class="input-group-text">{{country_code}}</label>
                    </div>
                    <input
                      name="phone"
                      v-model="employee.phone_number"
                      class="input form-control"
                      v-validate="'numeric|min: 7'"
                      :class="{'input': true, 'is-danger': errors.has('phone') }"
                      type="text"
                      v-bind:placeholder="$lang.messages.mobile_number"
                    />
                  </div>
                  <i v-show="errors.has('phone')" class="fa fa-warning"></i>
                  <span
                    v-show="errors.has('phone')"
                    class="help is-danger"
                  >{{$lang.messages.please_enter_10_digits_mobile_number}}</span>
                </div>

                <div class="col-lg-12 mb-4" v-if="employee.id === user.id">
                  <label for>{{$lang.messages.role}}</label>
                  <span style="color:#ff0000">*</span>
                  <div class="custom-select-dd">
                    <input type="text" class="input form-control" :value="employee.role" readonly />
                  </div>
                </div>
                <div class="col-lg-12 mb-4" v-else>
                  <label for>{{$lang.messages.role}}</label>
                  <span style="color:#ff0000">*</span>
                  <div class="custom-select-dd">
                    <select
                      v-model="employee.role_id"
                      v-validate="'required'"
                      name="role_id"
                      class="form-control"
                      @click="checkRolePos()"
                    >
                      <option value>{{$lang.messages.select_role}}</option>
                      <option v-for="role in roleList" :key="role.id" :value="role.id">{{role.name}}</option>
                    </select>

                    <i v-show="errors.has('role_id')" class="fa fa-warning"></i>
                    <span
                      v-show="errors.has('role_id')"
                      class="help is-danger"
                    >{{$lang.messages.please_select_role}}</span>
                  </div>
                </div>
                <!-- <div class="col-lg-12 mb-4" v-else>
                  <label for>{{$lang.messages.role}}</label>
                  <span style="color:#ff0000">*</span>
                  <div class="custom-select-dd">
                    <input type="text" class="input form-control" value="OWNER" readonly />
                  </div>
                </div> -->
                <div class="col-lg-12 mb-4" v-if="!employeeAdd && last_login">
                  <div class="form-group">
                    <span class="switch switch-sm">
                      <label for="switch-1">
                        <b>{{$lang.messages.last_login}} {{employee.last_login | moment("MMM DD, YYYY HH:mm")}}</b>
                      </label>
                    </span>
                  </div>
                </div>

                <div class="col-lg-12 mb-4">
                  <div class="card rounded-5 pt-1 border">
                    <div
                      class="card-header bg-white border-bottom cursor-pointer px-lg-5 px-4"
                      data-toggle="collapse"
                      data-target=".stores-list"
                      aria-expanded="true"
                      aria-controls="multiCollapseExample1 multiCollapseExample2"
                    >
                      <h4 class="font-20 d-inline">
                        {{$lang.messages.store}}
                        <span
                          class="font-16 ml-3 d-inline"
                        >{{availableStoreStr}}</span>
                      </h4>
                      <img
                        src="/images/down-arrow.svg"
                        width="15"
                        class="d-inline float-right mt-1"
                      />
                    </div>

                    <div class="card-body form-style collapse stores-list px-lg-5 px-4 show">
                      <form @submit.prevent="searchStores($event)" class="mb-3">
                        <div class="input-group input-group-lg">
                          <span class="input-group-append">
                            <button class="btn btn-outline-secondary" type="submit" style="height: 40pxborder-color: #c5c5c5">
                              <i class="fa fa-search"></i>
                            </button>
                          </span>
                          <input
                            type="text"
                            class="form-control input-lg"
                            v-model="query"
                            v-on:input="searchStores($event)"
                            :placeholder="$lang.messages.search_store"/>
                        </div>
                      </form>

                      <div class="custom-control custom-checkbox" v-if="query == ''">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="checkbox-1"
                          v-model="isAll"
                          @change="checkAllStores($event)"
                        />
                        <label v-if="isOwner"
                          class="custom-control-label text-dark ml-2"
                          for="checkbox-1"
                        >{{$lang.messages.automatically_assigned_to_all_stores}}</label>
                        <label v-else
                          class="custom-control-label text-dark ml-2"
                          for="checkbox-1"
                        >{{$lang.messages.assigned_to_all_stores}}</label>

                      </div>
                      <div class="dropdown-divider" style="border-top: 1px solid #c3c3c3" v-if="query == ''"></div>
                      <div>
                        <div
                          class="custom-control custom-checkbox mb-3"
                          v-for="store in storeList"
                          :key="store.id"
                        >
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :value="store.id"
                            :id="'type_'  +store.id"
                            v-model="selectedStores"
                            @change="checkUncheckStore($event)"
                          />

                          <label
                            class="custom-control-label text-dark ml-2"
                            :for="'type_' +store.id"
                          >{{store.name}}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer border-0 justify-content-center">
              <button
                type="button"
                class="btn btn-primary mr-3"
                @click="validateForm()"
                id="save-btn"
              >{{$lang.messages.save_btn_text}}</button>
              <button
                type="button"
                data-dismiss="modal"
                class="btn btn-outline-primary"
                id="cancel-btn"
              >{{$lang.messages.cancel_btn_text}}</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <Alert
      @rightButtonEvent="sendEmailEmployee($event)"
      v-bind:title="$lang.messages.send_employee_invitation_email"
      ref="sendEmailEmployeeAlert"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="send-email-employee-modal"
    />

    <Alert
      @rightButtonEvent="deleteEmployee($event)"
      v-bind:title="$lang.messages.delete_employee"
      ref="deleteEmployeeAlert"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="delete-employee-modal"
    />

    <Alert
      @rightButtonEvent="deleteSelectedEmployee($event)"
      v-bind:title="$lang.messages.delete_employee"
      ref="deleteMultipleEmployeeAlert"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="delete-multiple-employee-modal"
    />

    <Alert
      @rightButtonEvent="saveDuplicatedName($event)"
      v-bind:title="$lang.messages.employee"
      ref="duplicatedItemAlert"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="duplicated-customer-modal"
    />
    <Alert
      @rightButtonEvent="saveNoneCustomerStore($event)"
      v-bind:title="$lang.messages.employee"
      ref="noneCustomerStore"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="none-customer-store-modal"
    />

    <Alert
      @rightButtonEvent="saveAvailableAllStore($event)"
      v-bind:title="$lang.messages.employee"
      ref="confirmAvailableAllStores"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="confirm-available-all-store"
    />


    <a
      data-toggle="modal"
      data-target="#delete-multiple-employee-modal"
      ref="deleteMultipleEmployeeLink"
      style="display: none"
    />

    <a
      data-toggle="modal"
      data-target="#add-multiple-employee-modal"
      ref="addMultipleEmployeeLink"
      style="display: none"
    />
  </div>
</template>
